export default "__VITE_ASSET__877b0cef__"